import React from 'react';
import { useTransition } from 'react-spring';
import { ToastMessage } from '../../contexts/ToastContext';
import Toast from './Toast';

import './styles.css';

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages }) => {
  const messagesWithTransitions = useTransition(
    messages,
    (message) => message.id,
    {
      from: { right: '-120%', opacity: 0 },
      enter: { right: '0%', opacity: 1 },
      leave: { right: '-120%', opacity: 0 },
    }
  );
  return (
    <div className="toast-container">
      {messagesWithTransitions.map(({ item, key, props }) => (
        <Toast key={key} message={item} style={props} />
      ))}
    </div>
  );
};

export default ToastContainer;
